import React, { FunctionComponent, Ref } from 'react';
import cn from 'classnames/bind';
import Media from 'react-media';
import { LegalInfoItem } from '@plus-int/acq-toolkit';

import { Button } from '@/shared/components/Button/Button';
import PlayIcon from '@/shared/assets/MoviePlay';
import { InterpolatedOfferText } from '@/shared/components/InterpolatedOfferText/InterpolatedOfferText';

import { ChannelCardWallpaper } from '../ChannelCardWallpaper/ChannelCardWallpaper';
import { ChannelWallpaperManager } from '../../lib/channelWallpaperManager';
import { ChannelWallpaperItem } from '../../lib/utils/getChannelsWallpapers';

import styles from './ChannelCardModal.module.css';

const cx = cn.bind(styles);

interface Props {
    currentChannelWallpaper: ChannelWallpaperItem;
    offerInfoRef: Ref<HTMLDivElement>;
    title: string;
    offerText?: string;
    buttonText: string;
    subscriptionName: string | undefined;
    isOfferAvailable: boolean;
    wallpapperChannelsManager: ChannelWallpaperManager;
    onBuyButtonClick?: () => void;
    isLoginwallEnabled?: boolean;
    legals?: LegalInfoItem[];
}

export const ChannelCardModalComponent: FunctionComponent<Props> = ({
    currentChannelWallpaper,
    title,
    offerText,
    buttonText,
    subscriptionName,
    offerInfoRef,
    isOfferAvailable,
    wallpapperChannelsManager,
    onBuyButtonClick,
    isLoginwallEnabled,
    legals,
}) => (
    <div className={cx('content')} data-test-id="ChannelCardModal_content">
        <ChannelCardWallpaper
            className={cx('wallpaper')}
            currentChannelWallpaper={currentChannelWallpaper}
            wallpapperChannelsManager={wallpapperChannelsManager}
        />
        <div ref={offerInfoRef} className={cx('offer-details')}>
            {title && (
                <span className={cx('title')} data-test-id="ChannelCardModal_title">
                    {title}
                </span>
            )}
            {isOfferAvailable && (
                <>
                    <Media query="(min-width: 768px)">
                        {(match: boolean) => (
                            <Button
                                size={match ? 52 : 48}
                                variant={isLoginwallEnabled ? 'accent' : 'plus'}
                                startIcon={isLoginwallEnabled ? null : <PlayIcon fill="#fff" />}
                                onClick={onBuyButtonClick}
                                className={cx('watch-action')}
                                data-test-id="ChannelCardModal_offerButton"
                            >
                                {buttonText}
                            </Button>
                        )}
                    </Media>
                    {subscriptionName && !isLoginwallEnabled && (
                        <span className={cx('subscription-name')}>{subscriptionName}</span>
                    )}
                    {offerText && !isLoginwallEnabled && (
                        <span
                            className={cx('offer-text')}
                            data-test-id="ChannelCardModal_offerText"
                        >
                            <InterpolatedOfferText legals={legals} text={offerText} />
                        </span>
                    )}
                </>
            )}
        </div>
    </div>
);
